import { cn } from '$components'
import { LinkIcon } from '$components'
import { ReactNode } from 'react'
import { NavLink } from 'react-router-dom'

export type SidebarProps = {
  to: string,
  external?: boolean,
  children?: ReactNode,
}

export function SidebarLink({ to, children, external = false }: SidebarProps) {
  return (
    <NavLink
      to={to}
      target={external ? '_blank' : undefined}
      className={({ isActive }) => cn(
        'flex items-center gap-2 p-3 rounded-2xl text-sm text-gray-700',
        {
          'bg-gray-900 text-white': isActive,
          'hover:bg-gray-50': !isActive,
        },
      )}
    >
      { children }
      { external && (
        <LinkIcon className="size-3.5" />
      ) }
    </NavLink>
  )
}
